import { MDBCol, MDBIcon, MDBRow } from 'mdb-react-ui-kit';
import { useContext } from "react";
import useResumeBusinessSkillsHandlers from "../../../context/resume/hooks/resume-business-skills-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../../hooks/useCurrentUserRoles";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";

export default function CssfBusinessSkillsSection() {
    const { translations } = useContext(TranslationContext);
    const { documentLanguage } = useResumeProperties();
    const { businessSkills } = useResumeDocumentSection();
    const { handleRemoveCompetence } = useResumeBusinessSkillsHandlers();
    const { isManagerRole } = useCurrentUserRoles();

    return (
        <>
            <MDBRow>
                <MDBCol md="3" className="header-cv" style={ {
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "end",
                    color: "#009999",
                    fontSize: "14px"
                } }>
                    <span className="fw-bold" style={ { textAlign: "end" } }>
                        COMPÉTENCES
                    </span>
                </MDBCol>
                <MDBCol md="9" className="text-start" style={ { display: "flex", alignItems: "end" } }>
                    <hr style={ {
                        width: "95%",
                        margin: "0px",
                        height: "8px",
                        color: "#009999",
                        marginBottom: "8px",
                        opacity: "1"
                    } }/>
                </MDBCol>
            </MDBRow>
            { businessSkills
                ?.sort( ( a, b ) => a.order - b.order )
                .map( category => (
                    <>
                        <MDBRow style={ { marginTop: "10px" } }>
                            <MDBCol md="3" className="header-cv" style={ {
                                display: "flex",
                                alignItems: "start",
                                justifyContent: "end",
                                color: "#009999",
                                fontSize: "14px",
                                fontFamily: "Verdana, sans-serif"
                            } }>
                                <p className="text-end" style={ { fontSize: "14px" } }>Compétences techniques</p>
                            </MDBCol>
                            <MDBCol md="9" className="text-start" style={ {
                                display: "flex",
                                alignItems: "start",
                                flexDirection: "column",
                                justifyContent: "start"
                            } }>
                                <div
                                    className="d-flex flex-md-wrap flex-lg-wrap flex-sm-nowrap gap-2"
                                    style={ { maxWidth: "100%", fontSize: "11px", flexDirection: "column" } }
                                >
                                    { category.competences
                                        ?.sort( ( a, b ) => a.order - b.order )
                                        .map( ( competence, subIndex ) => (
                                            <div key={ subIndex }
                                                 className={ "gap-4 d-md-flex d-lg-flex" }
                                                 style={ {
                                                     alignItems: "center",
                                                     boxSizing: "border-box",
                                                 } }>
                                                { isManagerRole && (
                                                    <MDBIcon
                                                        far
                                                        icon="trash-alt"
                                                        style={ {
                                                            color: "#009999",
                                                            fontSize: "11px",
                                                            marginRight: "8px",
                                                            cursor: "pointer",
                                                            fontWeight: 'bold'
                                                        } }
                                                        onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemoveCompetence( competence, category.order ) }
                                                        role="button"
                                                        size="lg"
                                                    />
                                                ) }
                                                <span className="text-black"
                                                      style={ {
                                                          width: "100%",
                                                          alignItems: "center",
                                                          fontSize: "11px",
                                                          fontFamily: "Verdana, sans-serif"
                                                      } }
                                                >- { competence?.translations?.[ documentLanguage ] }{ ' ' }
                                                    { ( competence.level <= 2 ) && "(1)" }
                                                    { ( competence.level > 2 && competence.level <= 4 ) && "(2)" }
                                                    { ( competence.level > 4 ) && "(3)" }
                                                     </span>
                                            </div>
                                        ) ) }
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </>
                ) ) }
        </>
    );
}
